export class User {
  constructor(public username:string,
              public password:string) {
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user.ts